import React, { useEffect } from "react";
import { initMetaPixel } from "./utils/metaPixel";
import { Hero } from "./components/Hero";
import { OfferBar } from "./components/OfferBar";
import { TrustStrip } from "./components/TrustStrip";
import { ProblemsSection } from "./components/ProblemsSection";
import { SolutionSection } from "./components/SolutionSection";
import { BookSection } from "./components/BookSection";
import { SamplesCarousel } from "./components/SamplesCarousel";
import { OfferDetails } from "./components/OfferDetails";
import { GuaranteeSection } from "./components/GuaranteeSection";
import { FaqSection } from "./components/FaqSection";
import { ClosingSection } from "./components/ClosingSection";
import { SiteFooter } from "./components/SiteFooter";
import { StickyOfferBar } from "./components/StickyOfferBar";
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="23w4drynwuzzs">
      <Hero data-id="element-1" data-mp="3ik7fqfdqo9q4" />
      <OfferBar data-id="element-2" data-mp="3ikh5c1uvgeva" />
      <TrustStrip data-id="element-3" data-mp="3iiwg8rrbto4t" />
      <ProblemsSection data-id="element-4" data-mp="3ijfthv617oci" />
      <SolutionSection data-id="element-5" data-mp="3ii4ro0w5cqo1" />
      <BookSection data-id="element-6" data-mp="3ml14tc2x3ukl" />
      <SamplesCarousel data-id="element-7" data-mp="3mkhmhu9cv461" />
      <OfferDetails data-id="element-8" data-mp="3mjzpuwis6nxl" />
      <GuaranteeSection data-id="element-9" data-mp="3mj6ipufwtwex" />
      <FaqSection data-id="element-10" data-mp="3rcj31sdk3h1v" />
      <ClosingSection data-id="element-11" data-mp="3rbzpsoyupgu6" />
      <SiteFooter data-id="element-12" data-mp="3rcsw5otwe4bs" />
      <StickyOfferBar data-id="element-13" data-mp="3recdlirailf5" />
    </main>;
}